module.exports = __webpack_public_path__ + "media/images/favicon/favicon-17e0bad81062978c4097df37524dc03d.ico";